import React, { ReactNode } from "react";
import {View, Text} from "react-native";
import HomeComponent from "./components/HomeComponent";

class App extends React.Component{

    render(): ReactNode{
        return(
            <HomeComponent></HomeComponent>
        );
    }
}

export default App;

